import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: '18894f85-5399-4b53-bc9f-1ca4adb8d79f',
  header: 'Helsebiblioteket',
  headerLogoUrl: {
    light: '/logos/HB_logo.svg',
    dark: '/logos/HB_logo_dark.svg',
  },
  subheader: 'Sandkasse for Conteir og Helsebiblioteket',
  version: 'Alfa 1.0',
  logo: 'semantic_lab_logo_hvit.png',
  theme: {
    isLight: true,
    bgColor: 'bg-gray-800',
    textColor: 'text-fancy-wood',
    bubbles: 'gray-800',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/pediatri',
}
export default config
